module.exports = ".disableClick {\n  pointer-events: none;\n  color: #afafaf !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/gto-dashboard/gto-dashboard.component.css
// module id = ./src/app/components/dashboard/gto-dashboard/gto-dashboard.component.css
// module chunks = main